






















import { Component, Vue } from 'vue-property-decorator';
import { Organisation, User } from '@/models/User';
import { BModal } from 'bootstrap-vue';
import Jumbotron from '@/components/Jumbotron.vue';
import BaseUser from '@/components/User.vue';
import { mapGetters } from 'vuex';
import ModalUserConfig from '@/components/modals/UserConfig.vue';

@Component({
    components: {
        'jumbotron': Jumbotron,
        'b-modal': BModal,
        'base-user': BaseUser,
        'modal-user-config': ModalUserConfig,
    },
    computed: mapGetters({
        users: 'users/all',
        account: 'account/account',
        isOwner: 'organisation/isOwner',
        organisation: 'organisation/organisation',
    }),
})
export default class Users extends Vue {
    error: string = '';
    user: User = new User({});
    users!: User[];
    organisation!: Organisation;
}
